<app-list-load-error [error]="loadingError" (retry)="resetItems()" />

@if (items?.length === 0 && !loading && !loadingError) {
  @if (notFoundTemplate) {
    <ng-template [ngTemplateOutlet]="notFoundTemplate" />
  } @else {
    <div class="grow basis-0"></div>
    <app-no-content-stub imageSrc="assets/placeholders/placeholder-tasks.svg" [centered]="false">
      <div class="flex max-w-full flex-col items-center gap-2">
        @if (inTrash) {
          <p class="text-base font-medium text-gray-900 text-center">{{ narrowed ? NO_MATCH_TITLE : TRASH_EMPTY_TITLE }}</p>
        } @else if (inArchive) {
          <p class="text-base font-medium text-gray-900 text-center">{{ narrowed ? NO_MATCH_TITLE : ARCHIVE_EMPTY_TITLE }}</p>
        } @else {
          <p class="text-base font-medium text-gray-900 text-center">No tasks</p>
          <p class="text-sm text-gray-600 text-center">Start getting things done</p>
        }
      </div>
    </app-no-content-stub>
  }
}

<div
  #scrollableContainer
  class="overflow-y-auto grow basis-0 has-[app-list-items-separator]:scroll-pt-16"
  [class.px-8]="isCard()"
  appSelectableList
  #appSelectableList="appSelectableList"
  [deselectOnReclick]="false"
  [appSelectableListReset]="resetSelected"
  [appSelectableListItems]="items"
  (openSelected)="handleOpenSelected($event)"
>
  @if (loading && (!items || items.length === 0)) {
    <app-loading-indicator [inPanel]="true">Loading tasks...</app-loading-indicator>
  }

  @for (item of items; track item.data.id; let index = $index) {
    @if (item.showSectionHeader) {
      @if (filters.sortBy === 'priority') {
        <app-list-items-separator
          class="capitalize"
          [flush]="isCard()"
          [compact]="isCard() && compactCard()"
          [ruled]="isCard() && !$first">
          {{item.section}}
        </app-list-items-separator>
      } @else {
        <app-list-items-separator
          [value]="item.section"
          [flush]="isCard()"
          [compact]="isCard() && compactCard()"
          [ruled]="isCard() && !$first" />
      }
    }

    @if (item.data.pendingAssignment) {
      <span
        class="inline-flex rounded px-6 py-2 text-xs text-subdued bg-background-secondary"
        aria-label="Assignment awaiting acceptance"
        >Assignment</span
      >
    }
    <app-row-status-mark [row]="item.data" />
    <app-task-waiting-mark [task]="item.data" />
    @if (parentName(item.data); as parent) {
      <span class="px-2 text-xs text-subdued">Subtask of {{ parent }}</span>
    }
    @if (item.data.pendingReview) {
      <span class="px-2 text-xs" aria-label="Review awaiting your decision">Review</span>
    }
    <app-task
      [item]="item.data"
      [position]="index"
      [withTags]="withTags"
      [withKnots]="withKnots"
      [showLocationBadge]="showLocationBadge()"
      [actionsButtonEnabled]="actionsButtonEnabled()"
      [variant]="variant()"
      [previewedItemId]="previewedItemId()"
      [cardSelection]="cardSelection()"
      [compactCard]="compactCard()"
      [debug]="debug"
      (open)="openTask.emit(item.data)"
      (openSubtask)="openSubtask.emit($event)"
      (appDblClick)="handleDoubleClickItem(item.data)"
      class="block"
      [class.bg-background-highlight]="item.section === STICKY_ITEM_SECTION && !isCard()"
      [class.stitch-hub-card-lifted]="item.section === STICKY_ITEM_SECTION && isCard()"
      [appSelectable]="item.data"
      [appSelectablePosition]="index"
      [appSelectableIdentifier]="item.data.id"
      [appSelectableListRef]="appSelectableList"
    />
  }
</div>

<app-list-selection-bar [list]="appSelectableList" />

<app-pagination2
  [page]="displayedPage"
  [loading]="loading"
  [pageSize]="pageSize"
  (refresh)="resetItems()"
  (pageChange)="loadPage($event, true)"
  [totalItems]="totalCount"
  class="border-t border-border"
/>
